/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormaProrogaVoucher } from './forma-proroga-voucher';


export interface VoucherProrogaBandoForm { 
    /**
     * GIORNI: +N giorni alla scadenza di ciascun voucher; DATA: nuova scadenza unica
     */
    forma?: FormaProrogaVoucher;
    /**
     * Giorni da aggiungere (solo forma GIORNI, > 0)
     */
    giorni?: number;
    /**
     * Nuova data di scadenza, fine giornata (solo forma DATA)
     */
    data?: string;
    /**
     * Motivazione della proroga (obbligatoria alla proroga, non in anteprima)
     */
    motivo?: string;
}



